<template>
  <div>
    <b-card header-tag="header" no-body>
      <template #header>
        <header-sagres
          :titulo="detalhes ? 'Publicidade' : 'Nova publicidade'"
          breakpoint="xl"
        />
      </template>
      <b-overlay :show="overlayAnexo">
        <b-card-body>
          <b-container class="mt-3" v-if="!detalhes">
            <validation-observer
              ref="validationobserver"
              v-slot="{ handleSubmit }"
            >
              <b-form @submit.prevent="handleSubmit(adicionarAnexo)">
                <b-row style="text-align: left">
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      v-slot="defaultState"
                      label="Tipo do arquivo"
                    >
                      <b-form-select
                        v-model="idTipoArquivo"
                        :options="listaTipoArquivo"
                        :state="defaultState.state"
                      ></b-form-select>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="Arquivo"
                      v-slot="defaultState"
                    >
                      <b-form-file
                        accept=".pdf"
                        placeholder="Nenhum arquivo selecionado"
                        :state="defaultState.state"
                        v-model="arquivoAnexo"
                      ></b-form-file>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12">
                    <default-form-validation-provider
                      label="Detalhes"
                      v-slot="defaultState"
                      rules=""
                    >
                      <b-form-textarea
                        v-model="dsDetalhes"
                        placeholder="Informações adicionais sobre o arquivo (opcional)"
                        rows="2"
                        max-rows="3"
                        :state="defaultState.state"
                        maxlength="150"
                      ></b-form-textarea>
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="6"> </b-col>
                  <b-col cols="12" lg="6">
                    <div class="d-flex justify-content-end">
                      <b-button
                        type="submmit"
                        variant="secondary"
                        size="sm"
                        :disabled="!arquivoAnexo || !idTipoArquivo"
                        >Adicionar</b-button
                      >
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-container>

          <b-container class="mt-6">
            <b-table
              :items="listaAnexos"
              :fields="fields"
              striped
              hover
              show-empty
              stacked="xl"
              class="mt-3"
            >
              <template #cell(actions)="data">
                <div class="d-flex justify-content-around">
                  <b-overlay :show="overlayBaixar">
                    <b-button
                      size="sm"
                      @click="
                        baixarAnexo(data.item.NomeAnexo, data.item.IdAnexo)
                      "
                      ><font-awesome-icon icon="download" />
                    </b-button>
                  </b-overlay>
                  <b-button
                    size="sm"
                    @click="
                      alertaAnexoRemove(data.item.IdAnexo, data.item.NomeAnexo)
                    "
                    v-if="!detalhes"
                    ><font-awesome-icon icon="trash"
                  /></b-button>
                </div>
              </template>
              <template #empty>
                <div class="text-center text-muted">
                  Nenhuma publicidade cadastrada.
                </div>
              </template>
            </b-table>
          </b-container>
        </b-card-body>
      </b-overlay>
    </b-card>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { SelectValue } from "@/types/select-value";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { AnexoEdital } from "@/types/atos-pessoal/concursos/anexo";
import concursoService from "@/services/atos-pessoal/concursoService";
import { TipoAnexo } from "@/types/atos-pessoal/concursos/tipo-anexo";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { fieldsAnexosConcurso } from "@/types/atos-pessoal/concursos/fields-anexos";
import { TIPO_EDITAL_CODIGO } from "@/types/atos-pessoal/concursos/tipo-edital";

const CompProps = Vue.extend({
  name: "AbaAtoPublicidade",
  components: {
    DefaultFormValidationProvider,
    HeaderSagres,
    ValidationObserver,
  },
  props: {
    idEdital: {
      type: Number,
      required: true,
    },
    idTipoEdital: {
      type: Number,
      default: 0,
    },
    contador: {
      type: Number,
      required: true,
    },
    detalhes: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class AbaAtoPublicidade extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;

  idTipoArquivo: number | null = null;
  arquivoAnexo: any | null = null;
  dsDetalhes = "";

  listaTipoArquivo: SelectValue[] = [];
  listaAnexos: AnexoEdital[] = [];

  overlayAnexo = false;
  overlayBaixar = false;

  fields = fieldsAnexosConcurso;

  async mounted() {
    await this.carregarAnexos();
    await this.carregarTiposArquivo();
  }

  @Watch("contador")
  atualizar(newV) {
    if (newV) {
      this.carregarAnexos();
    }
  }

  @Watch("idTipoEdital")
  onTipoEditalChange() {
    this.carregarTiposArquivo();
  }

  async carregarTiposArquivo() {
    if (!this.idTipoEdital) return;
    try {
      this.overlayAnexo = true;
      const response = await concursoService.listarTiposArquivo(
        TIPO_EDITAL_CODIGO[this.idTipoEdital],
        "PUB"
      );
      this.listaTipoArquivo = [
        { text: "Selecione uma opção", value: null },
        ...response.map((ta: TipoAnexo) => ({
          value: ta.IdTipoAnexo,
          text: ta.DsTipoAnexo,
        })),
      ];
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayAnexo = false;
    }
  }

  async adicionarAnexo() {
    const isValid = await this.validationobserver.validate();
    if (!isValid) {
      this.$toast.error("Preencher campos obrigatórios (*)");
      return;
    }
    const data = {
      idEdital: this.idEdital,
      tipoAnexo: this.idTipoArquivo,
      Anexo: this.arquivoAnexo,
      dsDetalhes: this.dsDetalhes || undefined,
    };
    try {
      this.overlayAnexo = true;
      await concursoService.adicionarAnexo(data);
      this.resetarFormulario();
      this.$toast.success("Publicidade adicionada com sucesso!");
      await this.carregarAnexos();
      this.$emit("atualizarEdital");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayAnexo = false;
    }
  }

  resetarFormulario() {
    this.idTipoArquivo = null;
    this.arquivoAnexo = null;
    this.dsDetalhes = "";
    this.validationobserver.reset();
  }

  async carregarAnexos() {
    try {
      this.overlayAnexo = true;
      const response = await concursoService.listarAnexos(this.idEdital);
      this.listaAnexos = response.filter(
        (a: any) => a.IdTipoAnexoNavigation.TpGrupoAnexo === "PUB"
      );
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayAnexo = false;
    }
  }

  async excluirAnexo(id: number) {
    try {
      this.overlayAnexo = true;
      const response = await concursoService.excluirAnexo(id);
      this.$toast.success("Publicidade excluída com sucesso");
      this.listaAnexos = this.listaAnexos.filter(
        (a: AnexoEdital) => a.IdAnexo !== id
      );
      this.$emit("atualizarEdital");
      return response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayAnexo = false;
    }
  }

  async baixarAnexo(nomeArquivo: string, idArquivo: number) {
    try {
      this.overlayBaixar = true;
      const response = await concursoService.baixarAnexo(idArquivo);
      this.download(nomeArquivo, response.data);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayBaixar = false;
    }
  }

  download(filename: string, content: any): void {
    var element = document.createElement("a");
    element.setAttribute("href", URL.createObjectURL(content));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  alertaAnexoRemove(IdAnexo: number, nome: string) {
    this.$bvModal
      .msgBoxConfirm(`Deseja remover a publicidade ${nome}?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        okVariant: "secondary",
        title: "Remover publicidade",
      })
      .then((value) => {
        if (value) this.excluirAnexo(IdAnexo);
      })
      .catch((error) => {
        console.error(
          `Erro ao operar o dialogo de alerta de remoção de publicidade`,
          error
        );
      });
  }
}
</script>
